// @flow
import React from 'react';
import RouteStopEditForm from './RouteStopEditForm';
import styles from './routeStopEditPopupContainer.css';
import PopupContainer from '../PopupContainer';
import type { ID_TYPE } from '../../types/common';

type CreateUserPopupContentPropTypes = {
  routeStopId: ID_TYPE
}
const CreateUserPopupContent = ({ routeStopId }: CreateUserPopupContentPropTypes) => (
  <PopupContainer className={styles.content}>
    <RouteStopEditForm routeStopId={routeStopId} />
  </PopupContainer>
);

export default CreateUserPopupContent;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteStopEditPopupContainer/index.jsx